import { useEventListener } from '@passkeys/hooks';
import { useMemo } from 'react';

import exodus from '@/ui/exodus';
import {
  createMessageHandler,
  WALLET_DISCONNECT_MESSAGE,
} from '@/ui/utils/messages';
import { useNavigate } from '@/ui/utils/navigation';

function DisconnectMessageHandler(): null {
  const navigate = useNavigate();

  const handleMessage = useMemo(
    () =>
      createMessageHandler(WALLET_DISCONNECT_MESSAGE, () => {
        navigate('/');
        exodus.wallet.lock();
      }),
    [navigate],
  );

  useEventListener('message', handleMessage);

  return null;
}

export default DisconnectMessageHandler;
